import { createNode } from '../../util';
import { experiments } from '../experiments';

export const addWixRecorder = ({ sessionId, conversationId }): void => {
  if (experiments.is('specs.engage.enableGlassbox', 'true')) {
    const label: TProjectName = 'wix-chatbot-client';

    const script = createNode('script', {
      src: 'https://static.parastorage.com/unpkg-semver/wix-recorder@^1/app.bundle.min.js',
      async: true,
      crossOrigin: 'anonymous',
      onload() {
        window.wixRecorder.addLabel(label);
        window.wixRecorder.addCustomAttribute('session_id', sessionId);
        window.wixRecorder.addCustomAttribute('conversation_id', conversationId);

        this.onload = null;
      },
    });

    script.setAttribute('data-hook', 'wix-recorder');
    document.body.appendChild(script);
  }
};
